import { useEffect, useState } from 'react'
import BranchCard_dropdown from './BranchCard_dropdown';
import { hours } from '../../../dataSets/hours';

export default function BranchCard_activityDay({cardIndex, dayIndex, day, setDayData}) {
    const [openTerm, setOpenTerm] = useState(day?.startAt);
    const [closeTerm, setCloseTerm] = useState(day?.endAt);
    const [statusTerm, setStatusTerm] = useState(day?.isOpen);

    // A triger at any change at dependencies
    // If any of them change => return to parent the dayIndex of this current child
    // and the updated states
    // The parent save it in his own state and inform his own parent
    useEffect(()=>{
        setDayData(dayIndex, { ...day, startAt: openTerm, endAt: closeTerm, isOpen: statusTerm});
    },[openTerm, closeTerm, statusTerm])

    return (
        <div className="branchCard_activityDay" key={`branchCard_${cardIndex}_day_${dayIndex}`} dir='rtl'>
            <p className="branchCard_day">{day.day}</p>
            <div className='branchCard_isOpen'>
                <BranchCard_dropdown _class={"branchCard_activity_dropDown"} label={"סטטוס"} action={(e)=>{setStatusTerm(!statusTerm)}} _value={statusTerm} id={`branchCard_dropdown_inx_${cardIndex}_status`} options={["פתוח","סגור"]}/>
            </div>
            <div className="branchCard_OpenAt">
                <BranchCard_dropdown _class={"branchCard_activity_dropDown"} label={"שעת פתיחה"} action={(e)=>{setOpenTerm(e.target.value)}} _value={openTerm} id={`branchCard_dropdown_inx_${cardIndex}_open`} options={hours}/>
            </div>
            <div className="branchCard_CloseAt">
                <BranchCard_dropdown _class={"branchCard_activity_dropDown"} label={"שעת סגירה"} action={(e)=>{setCloseTerm(e.target.value)}} _value={closeTerm} id={`branchCard_dropdown_inx_${cardIndex}_close`} options={hours}/>
            </div>
        </div>
    )
}
